import { UnitQuantity } from '../../types';

export const serializeUnitQuantity = (
  raw: number
): UnitQuantity => {
  if (raw < 1) {
    throw new Error(
      'Количество единицы товара не может быть отрицательным'
    );
  }

  return raw as UnitQuantity;
};
